import { NamedItem } from 'domain/common/namedItem'
import { adminHttpClient } from '../../../commons/adminHttpClient'

export type UserToImport = {
  id: string
  firstName: string
  lastName: string
  workEmail: string
  employmentStatus: number
}

export type UsersFromExistingProductDTO = {
  usersToImport: UserToImport[]
  productClasses: NamedItem[]
}

const getUsersFromExistingProduct = (): Promise<UsersFromExistingProductDTO> => {
  return adminHttpClient.get('/Companies/UsersToImportFromExistingProduct')
}

export default getUsersFromExistingProduct
